module.exports = __webpack_public_path__ + "6299edcc32d8fe1ad19001195b5576bb.jpg";